import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { NavBar } from './NavBar';

/**
 * Main application layout.
 * Renders NavBar at top, page content via Outlet in the middle,
 * and a minimal footer at the bottom (hidden on chat pages).
 */
export function Layout(): React.JSX.Element {
  const location = useLocation();
  const isChatPage = location.pathname.includes('/chat');

  return (
    <div className="flex h-screen flex-col bg-surface overflow-hidden">
      <NavBar />

      {/* Page content */}
      <main className={isChatPage ? 'flex-1 overflow-hidden' : 'flex-1 overflow-auto'}>
        <Outlet />
      </main>

      {/* Minimal footer — hidden on chat pages */}
      {!isChatPage && (
        <footer className="border-t border-border bg-surface-raised py-6">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col items-center justify-between gap-2 sm:flex-row">
              <p className="text-sm text-text-muted">
                &copy; {new Date().getFullYear()} AppreciativeAI
              </p>
              <a
                href="/privacy"
                className="text-xs text-text-muted hover:text-text-secondary"
              >
                Privacy: Your data is yours. Your conversations are private. No ads, no tracking, no third‑party sharing.
              </a>
              <div className="flex items-center gap-3">
                <a
                  href="mailto:appreciativeai@gmail.com?subject=Feedback%20for%20AppreciativeAI"
                  className="text-sm text-text-muted underline hover:text-text-secondary"
                >
                  Feedback
                </a>
              </div>
            </div>
          </div>
        </footer>
      )}
    </div>
  );
}
